import type {
  MiddlewareAPI,
  Middleware,
} from '@reduxjs/toolkit';
import { isRejectedWithValue } from '@reduxjs/toolkit';

import { showAlert } from '../../reduxActions/alert';
import { deleteToken } from '../../reduxActions/tokenSlice';
import { openCanvaAuthWindow } from '../../pages/agrocraftArtisian/editImage/canvaAuthHelper';

const responseMiddleware: Middleware =
  (api: MiddlewareAPI) => (next) => (action) => {
    const { dispatch } = api;
    if (isRejectedWithValue(action)) {
      let message;
      const isCanvaApi = action.type.includes('canva');

      switch (action.payload.status) {
        case 401: {
          message = isCanvaApi
            ? action?.payload?.data?.error ||
              'Canva Access token is invalid'
            : 'Please login to continue';
          break;
        }
        default:
          message =
            action.data?.error ||
            action.payload?.data?.error ||
            action?.payload?.data;
      }
      dispatch(
        showAlert({
          content: message,
          severity: 'error',
        })
      );
      if (action.payload.status === 401) {
        if (isCanvaApi) {
          setTimeout(() => {
            dispatch(
              showAlert({
                content:
                  'In 5 Seconds you will be redirected to canva to get valid access token',
                severity: 'warning',
              })
            );
          }, 1000);
          setTimeout(() => {
            openCanvaAuthWindow();
          }, 5000);
        } else {
          localStorage.removeItem('authToken');
          dispatch(deleteToken());
          window.location.reload();
        }
      }
    }

    return next(action);
  };
export default responseMiddleware;
